import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import PageHero from "../components/site/PageHero";
import LeadForm from "../components/site/LeadForm";
import MeetTyler from "../components/site/sections/MeetTyler";
import { IMG, PHONE_DISPLAY, PHONE_TEL, EMAIL, LOCATION } from "../lib/site";
import Seo, { localBusinessSchema } from "../components/site/Seo";
import Breadcrumbs from "../components/site/Breadcrumbs";

const Contact = () => (
  <div>
    <Seo
      title="Contact PRYME EPOXY | Call Tyler for a Free Estimate"
      description="Contact PRYME EPOXY in Northern Arizona. Call Tyler at (928) 583-8100 or request a free, no-obligation estimate online. Serving Prescott, Flagstaff and Sedona."
      path="/contact"
      jsonLd={localBusinessSchema()}
    />
    <div className="hidden lg:block">
      <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }]} />
      <PageHero
        overline="Contact PRYME EPOXY"
        title="Talk to Tyler Today"
        subtitle="Call directly or request a free estimate below. No call centers, no pressure — just honest answers from the person who'll be on your job."
        image={IMG.blackGarage}
      />
    </div>

    <LeadForm />

    <MeetTyler />

    <section className="py-16 bg-zinc-950 border-b border-zinc-900">
      <div className="max-w-7xl mx-auto px-5 lg:px-12 grid grid-cols-1 md:grid-cols-4 gap-6">
        <a href={PHONE_TEL} className="border border-zinc-800 bg-[#141414] p-6 hover:border-[#C69453] transition-colors" data-testid="contact-phone-card">
          <Phone className="w-6 h-6 text-[#C69453]" />
          <p className="text-zinc-500 text-xs uppercase tracking-widest mt-4">Call Tyler</p>
          <p className="text-white font-bold text-lg mt-1">{PHONE_DISPLAY}</p>
        </a>
        <a href={`mailto:${EMAIL}`} className="border border-zinc-800 bg-[#141414] p-6 hover:border-[#C69453] transition-colors">
          <Mail className="w-6 h-6 text-[#C69453]" />
          <p className="text-zinc-500 text-xs uppercase tracking-widest mt-4">Email</p>
          <p className="text-white font-bold text-base mt-1 break-all">{EMAIL}</p>
        </a>
        <div className="border border-zinc-800 bg-[#141414] p-6">
          <MapPin className="w-6 h-6 text-[#C69453]" />
          <p className="text-zinc-500 text-xs uppercase tracking-widest mt-4">Based In</p>
          <p className="text-white font-bold text-lg mt-1">{LOCATION}</p>
        </div>
        <div className="border border-zinc-800 bg-[#141414] p-6">
          <Clock className="w-6 h-6 text-[#C69453]" />
          <p className="text-zinc-500 text-xs uppercase tracking-widest mt-4">Hours</p>
          <p className="text-white font-bold text-base mt-1">Mon–Sat, 7am–6pm</p>
        </div>
      </div>
    </section>

    <section className="bg-zinc-950 border-b border-zinc-900">
      <div className="border border-zinc-800 mx-5 lg:mx-12 my-10 overflow-hidden aspect-[16/6]">
        <iframe
          title="PRYME EPOXY service area — Prescott, Arizona"
          src="https://www.google.com/maps?q=Prescott,%20Arizona&output=embed"
          className="w-full h-full grayscale contrast-125"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  </div>
);

export default Contact;
